// File: src/components/AddPaperForm.js

import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";

const AddPaperForm = () => {
  const [form, setForm] = useState({
    title: "",
    authors: "",
    conference: "",
    firstDate: "",
    keywords: "",
    abstract: "",
    pdfLink: "",
    comment: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        
        const normalizedTitle = form.title.trim().toLowerCase();

        const papersRef = collection(db, "papers");
        const q = query(papersRef, where("title_normalized", "==", normalizedTitle));
        const snapshot = await getDocs(q);
        
        if (!snapshot.empty) {
            alert("A paper with this title has already been submitted.");
            return;
          }
        
        await addDoc(papersRef, {
            ...form,
            title: form.title.trim(),
            title_normalized: normalizedTitle, // this is critical
            authors: form.authors.split(",").map((a) => a.trim()),
            keywords: form.keywords.split(",").map((k) => k.trim()),
            votes: 0,
            visibility: "public",
            readers: "Everyone",
            source: "OpenReview",
        });
        alert("Paper added!");
        setForm({
            title: "",
            authors: "",
            conference: "",
            firstDate: "",
            keywords: "",
            abstract: "",
            pdfLink: "",
            comment: "",
        });

    } catch (err) {
      alert("Error adding paper: " + err.message);
    }
  };

  return (
    <div className="add-paper-form">
      <form onSubmit={handleSubmit} style={{ maxWidth: 600, margin: "0 auto" }}>
        <h2>Add Paper</h2>
        {["title", "authors", "conference", "firstDate", "keywords", "abstract", "pdfLink", "comment"].map((field) => (
          <div key={field} style={{ marginBottom: 12 }}>
            <label htmlFor={field}>{field}</label><br />
            <input
              id={field}
              type="text"
              name={field}
              value={form[field]}
              onChange={handleChange}
              style={{ width: "100%" }}
            />
          </div>
        ))}
        <button type="submit">Submit Paper</button>
      </form>
    </div>
  );
};

export default AddPaperForm;